<template>
    <div>
        <Breadcrumbs main="Admin" submain="Resources" title="Emergency Contact" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Contact</h7>
                            </button>
                        </div> 
    
                        <div class="card-body">
                            <b-row class="d-flex justify-content-center align-items-center">
                                <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #2c323f; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                        <feather type="filter"></feather>
                                        <h7>Filter</h7> 
                                    </div>

                                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="filterShow || shelter || type">
                                        <feather type="x"></feather>
                                        <h7>Clear All</h7>
                                    </div>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div class="row mt-2" v-if="filterShow">
                                <div class="col-md-6">
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <span>Shelter</span>
                                            <b-form-select v-model="shelter" :options="formattedShelters"></b-form-select>
                                        </div> 
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="grid-container mt-sm-0">
                                        <div class="grid-item">
                                            <span>Category</span>
                                            <b-form-select v-model="type" :options="formattedCategories"></b-form-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue mt-4">
                                    <b-table show-empty stacked="md" :items="contact_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(name)="row">
                                            <div v-if="row.item.name">
                                                <p>{{ row.item.name }}</p>
                                            </div>
                                        </template>

                                        <template #cell(phone)="row">
                                            <div v-if="row.item.phone">
                                                <p>{{ row.item.phone }}</p>
                                            </div>
                                        </template>

                                        <template #cell(contact)="row">
                                            <div v-if="row.item.contact_type">
                                                <p v-if="row.item.contact_type == 'shelter_committee'">Shelter Committee</p>
                                                <p v-if="row.item.contact_type == 'rescue_officials'">Rescue Officials</p>
                                                <p v-if="row.item.contact_type == 'govt_agencies'">Govt. agencies</p>
                                            </div>
                                        </template>

                                        <template #cell(shelter)="row">
                                            <div v-if="row.item.shelter">
                                                <p>{{ row.item.shelter.name }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteContact(data.item.id)" title="Delete"></feather>
                                                </div>
    
                                                <div @click="editContact(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Contact Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Emergency Contact" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter contact name" v-model="contact.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Phone</label>
                            <input class="form-control" type="text" placeholder="Enter contact number" v-model="contact.phone">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Category</label>
                            <select class="form-control digits" v-model="contact.contact_type ">
                                <option selected disabled>Select a category</option>
                                <option v-for="(category, index) in categories" :key="index" :value="category.value">{{ category.title }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Shelter</label>
                            <select class="form-control digits" v-model="contact.shelter">
                                <option selected disabled>Select a shelter</option>
                                <option v-for="(shelter, index) in shelters" :key="index" :value="shelter.id">{{ shelter.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Contact Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Emergency Contact" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Name</label>
                            <input class="form-control" type="text" placeholder="Enter contact name" v-model="edit_contact.name">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Phone</label>
                            <input class="form-control" type="text" placeholder="Enter contact number" v-model="edit_contact.phone">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Category</label>
                            <select class="form-control digits" v-model="edit_contact.contact_type ">
                                <option selected disabled>Select a category</option>
                                <option v-for="(category, index) in categories" :key="index" :value="category.value">{{ category.title }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Shelter</label>
                            <select class="form-control digits" v-model="edit_contact.shelter">
                                <option selected disabled>Select a shelter</option>
                                <option v-for="(shelter, index) in shelters" :key="index" :value="shelter.id">{{ shelter.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Contact Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this contact?</div>
        </b-modal>
    </div>
    </template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            loader
        },
    
        data() {
            return {
                host: myHost.host,
                filterShow: false,
                shelter: null,
                type: null,
                tablefields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'phone',
                        label: 'Phone',
                        sortable: true
                    },
                    {
                        key: 'contact',
                        label: 'Contact Type',
                        sortable: true
                    },
                    {
                        key: 'shelter',
                        label: 'Shelter',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
                contact: {
                    name: null,
                    phone: null,
                    contact_type : null,
                    shelter: null
                },
    
                edit_contact: {
                    id: null,
                    name: null,
                    phone: null,
                    shelter: null
                },

                categories: [
                    {
                        title: 'Shelter Committee',
                        value: 'shelter_committee'
                    },
                    {
                        title: 'Rescue Officials',
                        value: 'rescue_officials'
                    },
                    {
                        title: 'Govt. Agencies',
                        value: 'govt_agencies'
                    }
                ],
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 15, 20]
            };
        },
    
        computed: {
            ...mapState({
                contact_list: state => state.contact.contact_list,
                shelters: state => state.shelter.shelter,
                loading: state => state.contact.contactLoading,
                error: state => state.contact.contactError
            }),
    
            formattedShelters() {
                return [{
                        value: '',
                        text: 'Select a shelter',
                        disabled: true
                    },
                    ...this.shelters.map(shelter => ({
                        value: shelter.id,
                        text: shelter.name
                    }))
                ] 
            },

            formattedCategories() {
                return [{
                        value: '',
                        text: 'Select a category',
                        disabled: true
                    },
                    ...this.categories.map(shelter => ({
                        value: shelter.value,
                        text: shelter.title
                    }))
                ]
            }
        },

        watch: {
            shelter(newVal, oldVal) {
                if(this.shelter != null && this.type == null) {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list',
                        query: {
                            shelter: this.shelter
                        }
                    });
                } else if (this.shelter != null && this.type != null) {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list',
                        query: {
                            shelter: this.shelter,
                            type: this.type
                        }
                    });
                } else if (this.type != null && this.shelter == null) {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list',
                        query: {
                            type: this.type
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list'
                    });
                }

                this.$store.dispatch("contact/filterContacts", {
                    shelter: this.$route.query.shelter,
                    type: this.$route.query.type
                })
            },

            type(newVal, oldVal) {
                if(this.shelter != null && this.type == null) {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list',
                        query: {
                            shelter: this.shelter
                        }
                    });
                } else if (this.shelter != null && this.type != null) {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list',
                        query: {
                            shelter: this.shelter,
                            type: this.type
                        }
                    });
                } else if (this.type != null && this.shelter == null) {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list',
                        query: {
                            type: this.type
                        }
                    });
                } else {
                    this.$router.replace({
                        path: '/resources/emergency-contact/list'
                    });
                }

                this.$store.dispatch("contact/filterContacts", {
                    shelter: this.$route.query.shelter,
                    type: this.$route.query.type
                })
            },
        },
    
        mounted() {
            this.$store.dispatch("shelter/fetchShelter")
            this.$store.dispatch("contact/filterContacts", {
                shelter: this.$route.query.shelter,
                type: this.$route.query.type
            })
            // this.$store.dispatch("contact/fetchContact").then(() => {
            //     this.items = this.contact_list
            //     this.totalRows = this.contact_list.length;
            // });
        },
    
        methods: {
            clearFilter() {
                this.filterShow = false,
                this.shelter = null
                this.type = null

                this.$router.replace({
                    path: '/resources/emergency-contact/list'
                });
            },

            toggleFilterShow() {
                this.filterShow = !this.filterShow
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.contact.name = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
                this.$store.dispatch("contact/addContact", {
                    contact: this.contact
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.contact.name = null
                        this.contact.phone = null
                        this.contact.contact_type  = null
                        this.contact.shelter = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editContact(detail) {
                this.edit_contact.id = detail.id ? detail.id : null
                this.edit_contact.name = detail.name ? detail.name : null
                this.edit_contact.phone = detail.phone ? detail.phone : null
                this.edit_contact.contact_type  = detail.contact_type  ? detail.contact_type  : null
                this.edit_contact.shelter = detail.shelter ? detail.shelter.id : null
            },
    
            resetEditModal() {
                this.edit_contact.name = null
                this.edit_contact.phone = null
                this.edit_contact.contact_type  = null
                this.edit_contact.shelter = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
                this.$store.dispatch("contact/updateContact", {
                    id: this.edit_contact.id,
                    contact: this.edit_contact
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.edit_contact.name = null
                        this.edit_contact.phone = null
                        this.edit_contact.contact_type  = null
                        this.edit_contact.shelter = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteContact(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("contact/deleteContact", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.message,
                            icon: "success"
                        });
                        this.delete_value = null
    
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.message,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
    </script>
    